
// Follow guide at https://pinia.vuejs.org/core-concepts/

/*
* This store (global) primarily contains data from the server (lets refer as SSR), that is populated when the app first loads. This store is NOT reset on logout.
* The session store contains data that is populated after the user logs in. This store is reset on logout.
*
* TODO for Reactive Store:
*  Separate the current login data store stuff into things that should be reset on logout, and things that should not.
* So we need a app load store, and a app logged in store, and then view based ones.
* Would be great if we can get to a point where we can reset any of them at any time,
* and also for view stores, "store" a snapshot of the store that we can reinstate at any time.
*
* google more into the timetravel stuff, to see how it could apply to our app.
*
*
* TODO for this store: Perhaps if needed, we want to move the history stuff into a separate store, so that we can reset it at any time.
* But for now, lets not over complicate things.
* TODO: browser_steps_at_app_load? Refactor history_steps to history_stack.length and instead record the "Browser History Length" at the time of the first page load. So we can ensure back buttons do not take user out of the app to a previous website.
* */


import { defineStore } from 'pinia';

export const useGlobalStore = defineStore('global', {
	state: () => ({
		history_steps: 0, // TODO: Remove this in favour of counting the length of the history stack. However, there is a need for recording the "Browser History Length" at the time of the first page load. So we can ensure back buttons do not take user out of the app to a previous website.
		history_stack: [],
	}),
	getters: {
		getHistorySteps: (state) => state.history_steps,
		getPreviousHistoryItem: (state) => state.history_stack[ state.history_stack.length - 1 ],
	},
	actions: {
		incrementHistorySteps() {
			this.history_steps++
		},
		addToHistoryStack( history_item ) {
			this.history_stack.push( history_item )
		}
	},
})